'use strict';

import { GroupingPanelService } from './grouping-panel.service';
import { MxViewGroupByCtrl } from './mx-view-group-by';

angular
	.module('mx.SolutionBuilderAgent')
	.service('mx.SolutionBuilderAgent.GroupingPanelService', GroupingPanelService)
	.controller('mx.SolutionBuilderAgent.ViewGroupByController', MxViewGroupByCtrl);
